"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.z = void 0;
const zod_1 = require("zod");
Object.defineProperty(exports, "z", { enumerable: true, get: function () { return zod_1.z; } });
// Zod's default JIT/eval capability probe uses new Function("") which is
// reported as a CSP violation in strict environments without 'unsafe-eval'.
// Configure Zod before any schemas are created in this package.
zod_1.z.config({ jitless: true });
//# sourceMappingURL=zod.js.map